module.exports = __webpack_public_path__ + "static/img/9-9.9e0f995f.jpeg";